var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"template-create__wrapper"},[_c('div',{staticClass:"template-create-bottom"},[_c('div',{staticClass:"form-wrapper"},[_c('VForm',{attrs:{"fields":_vm.fields,"name":_vm.name,"hideSubmit":""}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }